import { Injectable } from '@angular/core';
import {ApiClass} from "../../../../../../data/class/api-class";
import {map} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ApiWorkerService extends ApiClass {

  constructor() {
    super()
    this.path = 'worker'
  }
  getWorkerId() {
    return this.getCollection('workerId').pipe(
      map((r) => r as { error: boolean; msg: string; data: { workerId: string } })
    );
  }


}
